import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UrlHelper } from '../utils/url.helper';
import { ClientService } from '../services/client.service';
import { Client } from '@mira-avant/mtlibs';

export const clientSubDomainSelectorGuard: CanActivateFn = async (route, state) => {
	const clientService = inject(ClientService);
	const subdomains: string = UrlHelper.getLeftMostSubDomains();

	try {
		// Select the client based on the current sub domain
		const client: Client = await clientService.getClientBySubDomain$(subdomains);

		await clientService.selectClient$(client.uuid);

		return true;
	} catch (err: any) {
		console.error('error selecting client', err);
		return false;
	}
};
